import { Alert } from "@mantine/core";
import { memo } from "react";
import { AlertPresets } from "../../../mantine/mantinePresets";
import { ChartCard } from "./ChartCard/ChartCard";
import { DetailCard } from "./DetailCard/DetailCard";
import { MetricCard } from "./MetricCard/MetricCard";
import { SourcesStrip } from "./SourcesStrip/SourcesStrip";
import { TableCard } from "./TableCard/TableCard";
import type { ToolResultData } from "./ToolResultRenderer.types";

interface ToolResultRendererProps {
  data: ToolResultData;
}

function ToolResultRendererComponent({ data }: ToolResultRendererProps) {
  if (data.type === "metric") {
    return <MetricCard data={data} />;
  }

  if (data.type === "chart") {
    return <ChartCard data={data} />;
  }

  if (data.type === "sources") {
    return <SourcesStrip data={data} />;
  }

  if (data.type === "detail") {
    return <DetailCard data={data} />;
  }

  if (data.type === "table") {
    return <TableCard data={data} />;
  }

  const _exhaustive: never = data;
  const unknownType = (_exhaustive as ToolResultData).type;

  return (
    <Alert {...AlertPresets.error} title="Fehler">
      Unbekannter Ergebnistyp: {unknownType}.
    </Alert>
  );
}

const ToolResultRenderer = memo(ToolResultRendererComponent);

export { ToolResultRenderer };
